import React, { useContext } from 'react';
import { SideMenuItem } from './SideMenuItem';
import { SideMenuHeader } from './SideMenuHeader';
import { TenantContext } from '../../context/TenantContext';
import { urls } from '../../logic/urls';

import {
    DropdownItem
} from 'reactstrap';

export const MobileMenu = () => {

    const tenantContext = useContext(TenantContext);


    const AdministrationMenuRendered = <>
        <SideMenuHeader text="Administration" />
        <SideMenuItem text="Licensing" icon="file-alt" url={urls.license} />
    </>;

    const BasicMenuRendered = <>
        <SideMenuHeader text="Basic" />
        <SideMenuItem text="Global" icon="globe" url={urls.tenant} />
        <SideMenuItem text="Portal access" icon="key" url={urls.portalAccess} />
        <SideMenuItem text="Device" icon="cogs" url={urls.device} />
    </>;

    return (
        <>
            {AdministrationMenuRendered}
            {BasicMenuRendered}
            <DropdownItem divider />
        </>
    )
}